const UI_ERROR_KEYS = {
  createProfile: 'CREATE_VISA_PLUS_PROFILE',
  profileAlreadyExists: 'VISA_PLUS_PROFILE_ALREADY_CREATED',
  eligibilityChecksPending: 'ELIGIBILITY_CHECKS_PENDING',
  notEligible: 'USER_INELIGIBLE',
}

export const VISA_ERROR_STATES = {
  CREATE_VISA_PLUS_PROFILE: {
    pathname: '/myaccount/transfer/visa-plus/onboard',
  },
  VISA_PLUS_PROFILE_ALREADY_CREATED: {
    pathname: '/myaccount/transfer/visa-plus/profile',
  },
  ELIGIBILITY_CHECKS_PENDING: {
    pathname: '/myaccount/transfer/visa-plus/nextsteps',
  },
  USER_INELIGIBLE: {
    pathname: '/myaccount/transfer/error',
  },
}

export function findRedirectPath(
  currentRoute,
  { evalResult = '', suggestedActions = '', failedReason = '' }
) {
  let retVal = {
    available: false,
    errorMessageType: UI_ERROR_KEYS.notEligible,
  }

  if (
    evalResult === 'USER_ELIGIBLE' &&
    suggestedActions === `CREATE_VISA_PLUS_PROFILE`
  ) {
    retVal = {
      available: currentRoute === 'onboard',
      errorMessageType: UI_ERROR_KEYS.createProfile,
    }
  } else if (evalResult === 'USER_INELIGIBLE') {
    if (failedReason === 'VISA_PLUS_PROFILE_ALREADY_CREATED') {
      retVal = {
        available: currentRoute === 'profile',
        errorMessageType: UI_ERROR_KEYS.profileAlreadyExists,
      }
    } else if (failedReason === 'ELIGIBILITY_CHECKS_PENDING') {
      retVal = {
        available: currentRoute === 'nextsteps',
        errorMessageType: UI_ERROR_KEYS.eligibilityChecksPending,
      }
    } else if (
      failedReason === 'COUNTRY_NOT_SUPPORTED' ||
      failedReason === 'ACCOUNT_TYPE_NOT_SUPPORTED'
    ) {
      return retVal
    }
  }
  return retVal
}
